var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.57,
    height: 18.47,
    viewBox: "0 0 20.57 18.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6f6",
    stroke: "#ec6525",
    d: "M13.913,4c-1.564,0-2.986,1.349-4.055,2.513C8.271,4.786,5.738,3.537,3.579,4.406A5.767,5.767,0,0,0,0,9.767c0,5.742,9.085,11.379,9.479,11.6a.6.6,0,0,0,.63,0c.376-.221,9.461-5.858,9.461-11.6A5.719,5.719,0,0,0,13.913,4Z",
    transform: "translate(0.5 -3.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoHeart);
export default __webpack_public_path__ + "static/media/picto_heart.22bd720b.svg";
export { ForwardRef as ReactComponent };